import { render, staticRenderFns } from "./addLeadSectionModal.vue?vue&type=template&id=6bbae59a&scoped=true"
import script from "./addLeadSectionModal.vue?vue&type=script&lang=js"
export * from "./addLeadSectionModal.vue?vue&type=script&lang=js"
import style0 from "./addLeadSectionModal.vue?vue&type=style&index=0&id=6bbae59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbae59a",
  null
  
)

export default component.exports